import { LoadingContext } from "../services/LoadingContext";
import { useContext } from "react";

export const useLoadingContext = () => {
    const context = useContext(LoadingContext);
    if (!context) {
      throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};